function toCents() {

  let toCentsDirective = {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {

      function toCents(euros) {
        return isNaN(euros) || Number(euros) < 0 ? undefined : Math.floor(euros/100);
      }

      function toEuro(cents) {
          return isNaN(cents) || Number(cents) < 0 ? undefined : cents;
      }

      ngModel.$parsers.push(toEuro);
      ngModel.$formatters.push(toCents);
    }
  };

  return toCentsDirective;

}

export default toCents;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/orderAndDelivery/toCents.directive.js
 **/